import React from "react";
import { Gamepad2, Sparkles, Users, Layers } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../data";

const experiences = [
  {
    icon: Gamepad2,
    title: "Gaming",
    body: "A space built around play, where gaming takes centre stage.",
    img: IMAGES.exp1,
    testid: "experience-gaming",
  },
  {
    icon: Sparkles,
    title: "Entertainment",
    body: "An energetic, welcoming atmosphere made for enjoyment.",
    img: IMAGES.exp2,
    testid: "experience-entertainment",
  },
  {
    icon: Users,
    title: "Community",
    body: "A shared destination where players come together in Jakarta.",
    img: IMAGES.community,
    testid: "experience-community",
  },
  {
    icon: Layers,
    title: "Immersive Experience",
    body: "Settle in and enjoy — many visitors stay for hours at a time.",
    img: IMAGES.hero,
    testid: "experience-immersive",
  },
];

export const Experience = () => (
  <section
    id="experience"
    data-testid="experience-section"
    className="relative py-24 md:py-32 scroll-mt-20"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="max-w-3xl">
        <Reveal>
          <p className="mb-5 inline-flex items-center gap-2 text-xs sm:text-sm tracking-[0.2em] uppercase font-bold text-neon">
            <span className="h-px w-8 bg-neon" /> 02 — The Experience
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl tracking-tight leading-tight">
            What to expect at MEGAWIN5K
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {experiences.map((e, i) => (
          <Reveal key={e.testid} delay={i * 0.08} className="group">
            <div
              data-testid={e.testid}
              className="relative h-full rounded-3xl overflow-hidden border border-white/10 group-hover:border-neon/40 transition-colors duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={e.img}
                  alt={`${e.title} at MEGAWIN5K game store in Jakarta`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0d] via-[#0b0b0d]/40 to-transparent" />
                <div className="absolute top-4 left-4 w-11 h-11 rounded-full glass flex items-center justify-center">
                  <e.icon size={20} className="text-neon" strokeWidth={1.5} />
                </div>
              </div>
              <div className="p-6 bg-white/[0.03]">
                <h3 className="font-display font-bold text-xl text-white">
                  {e.title}
                </h3>
                <p className="mt-2 text-sm text-white/60 leading-relaxed">
                  {e.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
